// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: block;
  width: 100%;
  margin-top: 1.5rem;
  overflow: auto;
}
:host .task-details {
  padding: 1rem;
  background-color: #fff;
  font-size: 14px;
}
:host .task-details .profile-img {
  position: absolute;
}
:host .task-details .post-date {
  font-size: 12px;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #8e8e8e;
  margin-right: 6px;
}
:host .task-details .ht-line {
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 100%;
  height: 1px;
  background: #dfe3eb;
}
:host .task-details .cs-select:invalid {
  color: #17a2b8;
  border: none;
  font-weight: 500;
}
:host .task-details .cs-activity {
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
}
:host ::-webkit-scrollbar-track {
  border-radius: 6px;
}
:host ::-webkit-scrollbar-thumb {
  border-radius: 6px;
}
:host .feedback-remarks .feedback {
  padding-right: 10px;
  font-family: Roboto-Medium;
}
:host .feedback-remarks .remarks {
  padding-right: 10px;
  font-family: Roboto-Medium;
}
:host .activity p {
  margin-bottom: 0;
}
:host .lead-activity-list {
  background-color: #f5f8fa;
  border-bottom: 1px solid #dfe3eb;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
